import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Grid, Button, Divider, MenuItem, TextField, Typography } from '@material-ui/core';
import { Add, Replay } from '@material-ui/icons';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import toJs from '../../../../hoc/toJS';
import select from '../../../../utils/select';

import ResearchTimeYearInsertModal from '../ResearchTimeYearInsertModal';
import ResearchTimeYearDeleteModal from '../ResearchTimeYearDeleteModal';

import {
	filterYear,
	getTimeResearchInformation
} from '../../../../reducer/timeResearchInformation/action';
import ResearchTimeYearAddOneModal from '../ResearchTimeYearAddOneModal/ResearchTimeYearAddOneModal';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			maxHeight: 300
		}
	})
);

function ResearchTimeButton(props) {
	const { year, filterYear, getTimeResearchInformation, timeResearchInformationList } = props;
	const classes = useStyles();
	const [deletingYear, setDeletingYear] = useState(false);
	const [insertingYear, setInsertingYear] = useState(false);
	const [addingYear, setAddingYear] = useState(false);
	const [initialValues, setInitialValues] = useState({
		description: '',
		numOfTime: 0,
		type: 'scientificResearch'
	});

	useEffect(() => {
		getTimeResearchInformation(0);
	}, []);

	// Nếu không có năm 2021 thì đổi sang năm khác
	useEffect(() => {
		const checkIndex = props.timeResearchInformationList?.findIndex((e) => e.year === props.year);
		if (checkIndex < 0 && props.timeResearchInformationList.length > 0) {
			props.filterYear(props.timeResearchInformationList[0]?.year);
		}
	}, [props.timeResearchInformationList]);

	useEffect(() => {
		const ascYears = timeResearchInformationList.sort((a, b) => b.year - a.year).map((e) => e.year);
		const currentTimeResearchInfo = timeResearchInformationList.filter(
			(e) => e.year === ascYears[0]
		)?.[0];
		setInitialValues({
			...initialValues,
			selectedYear: ascYears[0],
			timeResearchInformationId: currentTimeResearchInfo?.id
		});
	}, [timeResearchInformationList]);

	const handleDeleteYear = () => setDeletingYear(true);
	const handleInsertYear = () => setInsertingYear(true);
	const handleAddOne = () => setAddingYear(true);
	const handleReload = () => getTimeResearchInformation(0);
	const handleChangeYear = (e) => {
		const currentTimeResearchInfo = timeResearchInformationList.filter(
			(el) => el.year === parseInt(e.target.value)
		)?.[0];
		setInitialValues({
			...initialValues,
			selectedYear: parseInt(e.target.value),
			timeResearchInformationId: currentTimeResearchInfo.id
		});
		filterYear(parseInt(e.target.value));
	};

	const yearList = [];
	timeResearchInformationList.sort((a, b) => b.year - a.year).forEach((e) => yearList.push(e.year));

	return (
		<>
			<Grid container>
				<Grid item xs={3}>
					<Typography variant="h5" style={{ lineHeight: '36px' }}>
						Bảng tính giờ nghiên cứu
					</Typography>
				</Grid>
				<Grid item xs={6}>
					<Grid container spacing={1}>
						<Grid item xs={4}>
							<TextField
								select
								fullWidth
								size="small"
								variant="outlined"
								value={year}
								label="Chọn năm học"
								onChange={handleChangeYear}
								SelectProps={{
									MenuProps: {
										classes: { list: classes.root },
										anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
										transformOrigin: { vertical: 'top', horizontal: 'center' },
										getContentAnchorEl: null
									}
								}}
							>
								{yearList.map((e, index) => (
									<MenuItem key={index} value={parseInt(e)}>
										{e} - {e + 1}
									</MenuItem>
								))}
							</TextField>
						</Grid>
						<Grid item xs={4}>
							<Button
								variant="outlined"
								color="secondary"
								fullWidth
								onClick={handleDeleteYear}
								style={{ padding: '7px 0' }}
							>
								Xoá dữ liệu năm học
							</Button>
						</Grid>
						<Grid item xs={4}>
							<Button
								variant="outlined"
								color="primary"
								fullWidth
								onClick={handleInsertYear}
								style={{ padding: '7px 0' }}
							>
								Thêm dữ liệu năm học mới
							</Button>
						</Grid>
					</Grid>
				</Grid>

				<Grid item xs={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button variant="outlined" startIcon={<Replay />} onClick={handleReload}>
						Tải lại dữ liệu
					</Button>
					<Button
						variant="contained"
						color="primary"
						startIcon={<Add />}
						onClick={handleAddOne}
						style={{ marginLeft: 8 }}
					>
						Thêm nhiệm vụ
					</Button>
				</Grid>
			</Grid>
			<Divider style={{ margin: '8px 0' }} />

			<ResearchTimeYearDeleteModal
				deleting={deletingYear}
				setDeleting={setDeletingYear}
				handleReload={handleReload}
			/>
			<ResearchTimeYearInsertModal
				inserting={insertingYear}
				setInserting={setInsertingYear}
				handleReload={handleReload}
			/>

			<ResearchTimeYearAddOneModal
				adding={addingYear}
				setAdding={setAddingYear}
				handleReload={handleReload}
				initialValues={initialValues}
			/>
		</>
	);
}

const mapStateToProps = (state) => ({
	year: select(state, 'timeResearchInformationReducer', 'year'),
	timeResearchInformationList: select(state, 'timeResearchInformationReducer', 'list')
});

const mapDispatchToProps = (dispatch) => ({
	filterYear: (year) => dispatch(filterYear(year)),
	getTimeResearchInformation: (profileId) => dispatch(getTimeResearchInformation(profileId))
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ResearchTimeButton));
